module.exports = window["core-js/modules/es.array.iterator.js"];